module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/1_9c516cae70e02353dbeade39f2e1194c.png";